






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { createComponent, ref, watch, computed } from "@vue/composition-api";
import _ from "lodash";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import fileDownload from "js-file-download";
import ResourceItemView from "./ResourceItemView.vue";
import { useActions } from "@/shared/useMegaraxClient";
import { Resource } from "@megarax/client/src";
import { ListActions, CsvActions } from "@megarax/client/src/actions";
import { ResourceAppModule } from "@/shared/app";
import { getModulePath } from "../../apps/getPath";
import CsvDownloadButton from "../CsvDownloadButton.vue";
import DataDumpButton from "../DataDumpButton.vue";

interface Props {
  module: ResourceAppModule;
}

export default createComponent<Props>({
  name: "RevisionModulePage",
  components: { CsvDownloadButton, DataDumpButton },
  props: {
    module: {
      required: true,
    },
  },

  setup(props, ctx) {
    const actions = computed(() => useActions(props.module.resource));

    function onAddButtonClick() {
      ctx.root.$router.push(getModulePath(props.module, "new"));
    }

    const fetchingCsv = ref(false);

    function onItemSelect(item: ResourceItem) {
      ctx.root.$router.push(getModulePath(props.module, item.id!));
    }

    return {
      fetchingCsv,
      onAddButtonClick,
      onItemSelect,
      actions,
    };
  },
});
